import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { MidTeaserStreamImageProps } from '../Types'
import { MidTeaserImage } from '../Components'
import { ImageLabel } from '../../../../BaseComponents/Image/Components'
import { ChannelLogoTypes } from '../../../../Theme/Logos/LogoInterfaces'
import Tonal from '../../../../BaseComponents/Tonal'
import Sport1Logo from '../../../../Theme/Logos/Sport1'
import Sport1PlusLogo from '../../../../Theme/Logos/Sport1Plus'
import ESports1Logo from '../../../../Theme/Logos/eSports1'

const MidTeaserStreamImage = ({
    imageUrl,
    alt,
    labels,
    showTonal,
    logo,
    expand,
}: MidTeaserStreamImageProps): ReactElement => {
    const getLogo = (logo: ChannelLogoTypes): ReactElement => {
        switch (logo) {
            case 'sport1':
                return <Sport1Logo width={48} type="OnDark" />
            case 'sport1plus':
                return <Sport1PlusLogo width={48} type="OnDark" />
            case 'esports1':
                return <ESports1Logo width={48} type="OnDark" />
        }
    }
    return (
        <Grid noExpand width={!expand ? 290 : undefined} position="relative">
            {showTonal ? <Tonal borderRadius="4px" /> : null}
            <MidTeaserImage imageUrl={imageUrl} alt={alt} />
            {labels ? <ImageLabel labels={labels} /> : null}
            {logo ? (
                <Grid zIndex={5} position="absolute" width="100%" height="100%" alignRight alignTop>
                    <Grid noExpand margin={4}>
                        {getLogo(logo)}
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    )
}

export default MidTeaserStreamImage
